export const SAVE_BRANCH_ACTION = "save_branch";
export const GET_ALL_BRANCHES_SUCCESS_ACTION ="get_branches_success";
export const GET_ALL_BRANCHES_REQUEST_ACTION="get_all_branches_request";